/**
 * Appends the query string of the current page (e.g. UTM parameters) to a clickout URL, so marketing
 * tracking survives the jump to another domain.
 *
 * Parameters already present on the target URL win - a page parameter with the same key is not added,
 * so config-defined values like `?rightmart=true` are never overwritten or duplicated. The hash is kept.
 * If the target cannot be parsed as a URL it is returned unchanged.
 */
export const appendQueryString = (url: string, search: string): string => {
  const pageParams = new URLSearchParams(search);
  if (pageParams.toString() === '') return url;

  let target: URL;
  try {
    target = new URL(url);
  } catch {
    return url;
  }

  const targetKeys = new Set(target.searchParams.keys());
  pageParams.forEach((value, key) => {
    if (!targetKeys.has(key)) target.searchParams.append(key, value);
  });

  return target.toString();
};
